module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CheckoutFreeGift":{"progress":{"text":"Nakupte ještě za {price} {textBold}","textBold":"a dostanete dárek zdarma"},"active":"Dárek zdarma!"}},"en":{"CheckoutFreeGift":{"progress":{"text":"Buy for another {price} {textBold}","textBold":"and get a free gift"},"active":"Free gift!"}}}')
  delete Component.options._Ctor
}
